import axios from "axios"
import { BASE_URL } from "../../Utlils"


export const createQualDraftSurvey = async (data) => {
    try {
        const request = await axios.post(`${BASE_URL}/qualitative-project/create-draft`, data);
        return {
            success: true,
            message: 'Draft created successfully',
            data: request?.data
        }
    } catch (error) {
        return { success: false, message: error?.message || 'Unable to create draft !' }
    }
};

export const getSingleQualitativeProject = async (organizationID, projectID) => {
    try {
        const request = await axios.get(`${BASE_URL}/qualitative-project/single-project/${organizationID}/${projectID}`);
        const data = request?.data?.data;
        return data;
    } catch (error) {
        console.log("something went wrong while fetching the project details", error);
        throw error?.message || 'Unable to fetch project details !';
    }
}

export const getAllQualitativeProjects = async (data) => {
    try {
        const request = await axios.post(`${BASE_URL}/qualitative-project/${data?.organizationID}/all-projects`, data);
        const response = request?.data;
        return response;
    } catch (error) {
        console.log("unable to get all qualitative projects", error);
        throw error?.message || 'Unable to get all qualitative projects !';
    }
};

export const getAllQualitativeProjectsCount = async (data) => {
    try {
        const request = await axios.post(`${BASE_URL}/qualitative-project/${data?.organizationID}/all-projects-count`, data);
        const response = request?.data;
        return response;
    } catch (error) {
        console.log("unable to get all qualitative projects count", error);
        throw error?.message || 'Unable to get all qualitative projects count !';
    }
};

export const updateQualitativeProject = async ({ organizationID, projectID, payload }) => {
    try {
        const request = await axios.patch(
            `${BASE_URL}/qualitative-project/update-project/${organizationID}/${projectID}`,
            payload
        );
        return { success: true, data: request?.data?.project };
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || error?.message || "Unable to update project!",
            errors: error?.response?.data?.errors || [],
        };
    }
}
export const deleteQualitativeProject = async ({ organizationID, projectID }) => {
    try {
        const request = await axios.delete(
            `${BASE_URL}/qualitative-project/delete-project/${organizationID}/${projectID}`
        );
        return { success: true, data: request?.data };
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || error?.message || "Unable to delete project!",
        };
    }
};
export const submitQualitativeProject = async ({ organizationID, projectID }) => {
    try {
        const request = await axios.post(
            `${BASE_URL}/qualitative-project/submit-project/${organizationID}/${projectID}`
        );
        return { success: true, data: request?.data };
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || error?.message || "Unable to submit project!",
            errors: error?.response?.data?.errors || [],
        };
    }
};

export const getSurveyParticipantOverviewStats = async ({ organizationID, projectID, payload, reset = false }) => {
    try {
        const request = await axios.post(`${BASE_URL}/qualitative-project/${projectID}/allocations/${organizationID}/overview-stats`, { reset });
        const data = request?.data;
        return data;
    } catch (error) {
        return { success: false, message: error?.message || 'Unable to create draft !' }
    }
};

export const getAllSurveyAllocations = async (data) => {
    try {
        const { project, status } = data;
        const request = await axios.post(`${BASE_URL}/qualitative-project/${project}/allocations/${status}/allocations`, data);
        const result = request?.data;
        return result;
    } catch (error) {
        throw new Error(error?.message || 'Unable to get all allocations !');
    }
}

export const toggleProjectToPause = async ({ organizationID, projectID }) => {
    try {
        const request = await axios.patch(
            `${BASE_URL}/qualitative-project/pause-project/${organizationID}/${projectID}`
        );
        return { success: true, data: request?.data };
    } catch (error) {
        return {
            success: false,
            message: error?.response?.data?.message || error?.message || "Unable to pause project!",
        };
    }
}
